var map = {
	"./": 64191,
	"./components/ContactSection/ContactSection": 6379,
	"./components/ContactSection/ContactSection.jsx": 6379,
	"./components/Footer/Footer": 31875,
	"./components/Footer/Footer.jsx": 31875,
	"./components/Footer/footer_logo.png": 70838,
	"./components/Gallery/Gallery": 19409,
	"./components/Gallery/Gallery.jsx": 19409,
	"./components/GenericInfoPage/GenericInfoPage": 582,
	"./components/GenericInfoPage/GenericInfoPage.jsx": 582,
	"./components/GenericInfoSection/GenericInfoSection": 36038,
	"./components/GenericInfoSection/GenericInfoSection.jsx": 36038,
	"./components/Header/Header": 58396,
	"./components/Header/Header.jsx": 58396,
	"./components/Header/Navigation/Navigation": 88477,
	"./components/Header/Navigation/Navigation.jsx": 88477,
	"./components/Header/logo.png": 51616,
	"./components/Helpers/ScrollToTop": 66267,
	"./components/Helpers/ScrollToTop.jsx": 66267,
	"./components/Home/About/About": 82740,
	"./components/Home/About/About.jsx": 82740,
	"./components/Home/About/about_01.jpg": 8890,
	"./components/Home/Clients/Clients": 83651,
	"./components/Home/Clients/Clients.jsx": 83651,
	"./components/Home/Clients/quote_image_02.jpg": 8903,
	"./components/Home/Clients/quote_image_03.jpg": 3385,
	"./components/Home/Clients/quote_image_04.jpg": 51654,
	"./components/Home/Contact/Contact": 24177,
	"./components/Home/Contact/Contact.jsx": 24177,
	"./components/Home/Home": 47842,
	"./components/Home/Home.jsx": 47842,
	"./components/Home/HomeSection/HomeSection": 54085,
	"./components/Home/HomeSection/HomeSection.jsx": 54085,
	"./components/Home/Milestones/Milestones": 5401,
	"./components/Home/Milestones/Milestones.jsx": 5401,
	"./components/Home/News/News": 22634,
	"./components/Home/News/News.jsx": 22634,
	"./components/Home/News/blog_img_01.jpg": 3610,
	"./components/Home/News/blog_img_02.jpg": 61893,
	"./components/Home/News/blog_img_03.jpg": 18704,
	"./components/Home/Portfolio/Portfolio": 12489,
	"./components/Home/Portfolio/Portfolio.jsx": 12489,
	"./components/Home/Portfolio/portfolio_item_01.jpg": 19318,
	"./components/Home/Portfolio/portfolio_item_02.jpg": 89747,
	"./components/Home/Portfolio/portfolio_item_03.jpg": 20691,
	"./components/Home/Portfolio/portfolio_item_04.jpg": 73866,
	"./components/Home/Pricing/Pricing": 61662,
	"./components/Home/Pricing/Pricing.jsx": 61662,
	"./components/Home/Services/Services": 46749,
	"./components/Home/Services/Services.jsx": 46749,
	"./components/Home/Skills/Skills": 56745,
	"./components/Home/Skills/Skills.jsx": 56745,
	"./components/Home/Team/Team": 96482,
	"./components/Home/Team/Team.jsx": 96482,
	"./components/Home/Team/about_item_01.jpg": 18377,
	"./components/Home/Team/about_item_02.jpg": 55555,
	"./components/Home/Team/about_item_03.jpg": 33295,
	"./components/ScrollButton/ScrollBottomButton": 80274,
	"./components/ScrollButton/ScrollBottomButton.jsx": 80274,
	"./components/ScrollButton/ScrollTopButton": 14375,
	"./components/ScrollButton/ScrollTopButton.jsx": 14375,
	"./components/SimpleInfoSection/SimpleInfoSection": 43989,
	"./components/SimpleInfoSection/SimpleInfoSection.jsx": 43989,
	"./components/TextAndTwoButtons/TextAndTwoButtons": 84569,
	"./components/TextAndTwoButtons/TextAndTwoButtons.jsx": 84569,
	"./components/TextCards/TextCards": 89562,
	"./components/TextCards/TextCards.jsx": 89562,
	"./fonts/FontAwesome.otf": 71606,
	"./fonts/fontawesome-webfont.eot": 94174,
	"./fonts/fontawesome-webfont.svg": 34717,
	"./fonts/fontawesome-webfont.ttf": 41352,
	"./fonts/fontawesome-webfont.woff": 38014,
	"./fonts/fontawesome-webfont.woff2": 19288,
	"./hooks/useWindowDimension": 68125,
	"./hooks/useWindowDimension.js": 68125,
	"./images/05_DarkBacground.png": 67618,
	"./images/404.png": 62813,
	"./images/6_elegant_BW_spotlight_background.png": 74762,
	"./images/CPR-guide.png": 62691,
	"./images/Paianu_Vlad_CIM copy.pdf": 36264,
	"./images/about/IMG_2944_edited.webp": 83973,
	"./images/about/IMG_2956.webp": 67018,
	"./images/about/IMG_2977_edited.webp": 26117,
	"./images/about/IMG_2984.webp": 44033,
	"./images/about/about_collage.png": 12976,
	"./images/about/contact.png": 5868,
	"./images/about/heaven_1.jpeg": 20199,
	"./images/about/heaven_2.jpeg": 74688,
	"./images/about/heaven_3.jpeg": 53979,
	"./images/about/heaven_4.jpeg": 56894,
	"./images/about/img_1.jpeg": 64282,
	"./images/about/img_10.jpeg": 8917,
	"./images/about/img_11.jpeg": 66666,
	"./images/about/img_5.jpeg": 64038,
	"./images/about/img_6.jpeg": 90786,
	"./images/about/img_7.jpeg": 53164,
	"./images/about/img_8.jpeg": 22611,
	"./images/about/img_9.jpeg": 62254,
	"./images/about/playRoom/img_1.jpg": 57211,
	"./images/about/playRoom/img_10.jpg": 9348,
	"./images/about/playRoom/img_11.jpg": 64751,
	"./images/about/playRoom/img_2.jpg": 41566,
	"./images/about/playRoom/img_3.jpg": 864,
	"./images/about/playRoom/img_4.jpg": 94432,
	"./images/about/playRoom/img_5.jpg": 77926,
	"./images/about/playRoom/img_6.jpg": 20618,
	"./images/about/playRoom/img_7.jpg": 11422,
	"./images/about/playRoom/img_8.jpg": 11491,
	"./images/about/playRoom/img_9.jpg": 48427,
	"./images/about/timi1.webp": 72101,
	"./images/about/timi2.webp": 70161,
	"./images/about/timi3.webp": 97047,
	"./images/about/timi4.webp": 71103,
	"./images/about/video/video1.mp4": 47125,
	"./images/about/video/video2.mp4": 75059,
	"./images/about/video/video3.mp4": 50397,
	"./images/ack.jpg": 3409,
	"./images/books/img_1.jpg": 25024,
	"./images/books/img_2.jpg": 77795,
	"./images/books/img_3.jpg": 62740,
	"./images/books/img_4.jpg": 87356,
	"./images/books/img_5.jpg": 98054,
	"./images/businessCard.png": 39647,
	"./images/champions/EU/aria/img_2.jpg": 50902,
	"./images/champions/EU/aria/img_3.jpg": 15553,
	"./images/champions/EU/aria/img_4.jpg": 80843,
	"./images/champions/EU/aria/img_5.jpg": 20428,
	"./images/champions/EU/aria/img_6.jpg": 45370,
	"./images/champions/EU/aria/img_7.jpg": 49042,
	"./images/champions/EU/aria/img_8.jpg": 99148,
	"./images/champions/EU/aria/img_9.jpg": 24563,
	"./images/champions/EU/autumn/1/img_1.jpg": 78258,
	"./images/champions/EU/autumn/1/img_2.jpg": 81710,
	"./images/champions/EU/autumn/2/img_1.jpg": 30703,
	"./images/champions/EU/autumn/2/img_10.png": 10215,
	"./images/champions/EU/autumn/2/img_2.jpg": 36911,
	"./images/champions/EU/autumn/2/img_3.jpg": 48273,
	"./images/champions/EU/autumn/2/img_4.jpg": 75164,
	"./images/champions/EU/autumn/2/img_5.jpg": 75265,
	"./images/champions/EU/autumn/2/img_6.jpg": 75720,
	"./images/champions/EU/autumn/2/img_7.png": 62429,
	"./images/champions/EU/autumn/2/img_8.jpg": 61918,
	"./images/champions/EU/autumn/2/img_9.jpg": 39366,
	"./images/champions/EU/autumn/3/img_1.jpg": 54630,
	"./images/champions/EU/autumn/3/img_10.jpg": 99732,
	"./images/champions/EU/autumn/3/img_2.jpg": 94310,
	"./images/champions/EU/autumn/3/img_3.jpg": 36418,
	"./images/champions/EU/autumn/3/img_4.jpg": 34073,
	"./images/champions/EU/autumn/3/img_5.jpg": 38420,
	"./images/champions/EU/autumn/3/img_6.jpg": 41625,
	"./images/champions/EU/autumn/3/img_7.jpg": 12012,
	"./images/champions/EU/autumn/3/img_8.jpg": 44710,
	"./images/champions/EU/autumn/3/img_9.jpg": 88510,
	"./images/champions/EU/autumn/4/img_0.png": 20151,
	"./images/champions/EU/autumn/4/img_1.jpg": 30632,
	"./images/champions/EU/autumn/4/img_2.jpg": 8861,
	"./images/champions/EU/autumn/4/img_3.jpg": 87157,
	"./images/champions/EU/autumn/4/img_4.jpg": 44590,
	"./images/champions/EU/autumn/4/img_5.jpg": 19732,
	"./images/champions/EU/autumn/4/img_6.jpg": 91925,
	"./images/champions/EU/autumn/4/img_7.jpg": 94450,
	"./images/champions/EU/autumn/4/img_8.jpg": 68191,
	"./images/champions/EU/autumn/4/img_9.webp": 75517,
	"./images/champions/EU/autumn/5/img_1.jpg": 26083,
	"./images/champions/EU/autumn/5/img_2.png": 32362,
	"./images/champions/EU/autumn/5/img_3.jpg": 54936,
	"./images/champions/EU/autumn/5/img_4.jpg": 88896,
	"./images/champions/EU/autumn/5/img_5.jpg": 40381,
	"./images/champions/EU/autumn/5/img_6.jpg": 14271,
	"./images/champions/EU/autumn/5/img_7.jpg": 42352,
	"./images/champions/EU/bob/img_1.jpg": 5517,
	"./images/champions/EU/bob/img_10.jpg": 55603,
	"./images/champions/EU/bob/img_11.jpg": 34148,
	"./images/champions/EU/bob/img_2.jpg": 91698,
	"./images/champions/EU/bob/img_3.jpg": 76660,
	"./images/champions/EU/bob/img_4.jpg": 86796,
	"./images/champions/EU/bob/img_5.jpg": 24375,
	"./images/champions/EU/bob/img_6.jpg": 39921,
	"./images/champions/EU/bob/img_7.jpg": 36001,
	"./images/champions/EU/bob/img_8.jpg": 37139,
	"./images/champions/EU/bob/img_9.jpg": 26981,
	"./images/champions/EU/carousel1/img_1.png": 39265,
	"./images/champions/EU/carousel1/img_2.png": 94227,
	"./images/champions/EU/carousel1/img_3.png": 28508,
	"./images/champions/EU/carousel1/img_4.png": 26933,
	"./images/champions/EU/carousel1/img_5.png": 62976,
	"./images/champions/EU/carousel1/img_6.png": 52073,
	"./images/champions/EU/carousel2/img_1.png": 82278,
	"./images/champions/EU/carousel2/img_10.png": 78865,
	"./images/champions/EU/carousel2/img_11.png": 71927,
	"./images/champions/EU/carousel2/img_12.png": 49173,
	"./images/champions/EU/carousel2/img_13.png": 58990,
	"./images/champions/EU/carousel2/img_14.jpg": 96873,
	"./images/champions/EU/carousel2/img_2.png": 1803,
	"./images/champions/EU/carousel2/img_3.png": 31340,
	"./images/champions/EU/carousel2/img_4.png": 58959,
	"./images/champions/EU/carousel2/img_5.png": 65712,
	"./images/champions/EU/carousel2/img_6.png": 43604,
	"./images/champions/EU/carousel2/img_7.png": 80820,
	"./images/champions/EU/carousel2/img_8.png": 63038,
	"./images/champions/EU/carousel2/img_9.png": 74852,
	"./images/champions/EU/flying/img_0.jpg": 52870,
	"./images/champions/EU/flying/img_1.jpg": 21077,
	"./images/champions/EU/flying/img_2.jpg": 26780,
	"./images/champions/EU/flying/img_3.jpg": 14696,
	"./images/champions/EU/izabella/img_1.jpg": 25885,
	"./images/champions/EU/izabella/img_2.jpg": 26226,
	"./images/champions/EU/izabella/img_3.jpg": 55048,
	"./images/champions/EU/izabella/img_4.jpg": 9460,
	"./images/champions/EU/izabella/img_5.jpg": 23539,
	"./images/champions/EU/izabella/img_6.jpg": 76693,
	"./images/champions/EU/izabella/img_7.jpg": 17005,
	"./images/champions/EU/maya/img_1.jpg": 63828,
	"./images/champions/EU/maya/img_10.jpg": 65421,
	"./images/champions/EU/maya/img_11.jpg": 27582,
	"./images/champions/EU/maya/img_12.png": 75787,
	"./images/champions/EU/maya/img_2.jpg": 79643,
	"./images/champions/EU/maya/img_3.jpg": 61185,
	"./images/champions/EU/maya/img_4.jpg": 94737,
	"./images/champions/EU/maya/img_5.jpg": 15372,
	"./images/champions/EU/maya/img_6.jpg": 69497,
	"./images/champions/EU/maya/img_7.jpg": 53183,
	"./images/champions/EU/maya/img_8.jpg": 70091,
	"./images/champions/EU/maya/img_9.jpg": 73394,
	"./images/champions/EU/maya/lugoj/img_0.jpg": 106,
	"./images/champions/EU/maya/lugoj/img_1.jpg": 74606,
	"./images/champions/EU/maya/lugoj/img_2.jpg": 84527,
	"./images/champions/EU/maya/lugoj/img_3.jpg": 13939,
	"./images/champions/EU/maya/lugoj/img_4.jpg": 78913,
	"./images/champions/EU/maya/lugoj/img_5.jpg": 84312,
	"./images/champions/EU/maya/lugoj/img_6.jpg": 85464,
	"./images/champions/EU/maya/us/img_1.jpg": 66237,
	"./images/champions/EU/maya/us/img_2.jpg": 71443,
	"./images/champions/EU/maya/us/img_3.jpg": 45960,
	"./images/champions/EU/maya/us/img_4.jpg": 98774,
	"./images/champions/EU/maya/us/img_5.jpg": 76622,
	"./images/champions/US/angels/julia/img_1.png": 24608,
	"./images/champions/US/angels/julia/img_10.png": 39200,
	"./images/champions/US/angels/julia/img_11.png": 56496,
	"./images/champions/US/angels/julia/img_12.png": 37072,
	"./images/champions/US/angels/julia/img_13.png": 54239,
	"./images/champions/US/angels/julia/img_14.png": 96097,
	"./images/champions/US/angels/julia/img_15.png": 75739,
	"./images/champions/US/angels/julia/img_2.png": 32913,
	"./images/champions/US/angels/julia/img_3.png": 63627,
	"./images/champions/US/angels/julia/img_4.png": 33854,
	"./images/champions/US/angels/julia/img_5.png": 82931,
	"./images/champions/US/angels/julia/img_6.png": 51555,
	"./images/champions/US/angels/julia/img_7.png": 44388,
	"./images/champions/US/angels/julia/img_8.png": 43547,
	"./images/champions/US/angels/julia/img_9.png": 28333,
	"./images/champions/US/angels/karina/img_1.png": 13780,
	"./images/champions/US/angels/karina/img_2.png": 4780,
	"./images/champions/US/angels/karina/img_3.png": 70717,
	"./images/champions/US/angels/karina/img_4.png": 96293,
	"./images/champions/US/angels/karina/img_5.png": 36180,
	"./images/champions/US/angels/karina/img_6.png": 85163,
	"./images/champions/US/angels/karina/img_7.png": 25070,
	"./images/champions/US/angels/karina/img_8.png": 33826,
	"./images/champions/US/angels/karina/img_9.png": 48118,
	"./images/champions/US/angels/momo/momo.jpeg": 36737,
	"./images/champions/US/angels/ozzie/ozzie_1.png": 23773,
	"./images/champions/US/angels/ozzie/ozzie_2.png": 66041,
	"./images/champions/US/females/aida/img_1.jpg": 37562,
	"./images/champions/US/females/aida/img_10.jpg": 95386,
	"./images/champions/US/females/aida/img_11.jpg": 57093,
	"./images/champions/US/females/aida/img_12.jpg": 52321,
	"./images/champions/US/females/aida/img_13.jpg": 34071,
	"./images/champions/US/females/aida/img_2.jpg": 85553,
	"./images/champions/US/females/aida/img_3.jpg": 92958,
	"./images/champions/US/females/aida/img_4.jpg": 28900,
	"./images/champions/US/females/aida/img_5.jpg": 13024,
	"./images/champions/US/females/aida/img_6.jpg": 22263,
	"./images/champions/US/females/aida/img_7.jpg": 31848,
	"./images/champions/US/females/aida/img_8.jpg": 44498,
	"./images/champions/US/females/aida/img_9.jpg": 39285,
	"./images/champions/US/females/chianti/img_1.jpg": 25599,
	"./images/champions/US/females/chianti/img_10.jpg": 72522,
	"./images/champions/US/females/chianti/img_11.jpg": 38430,
	"./images/champions/US/females/chianti/img_12.jpg": 71425,
	"./images/champions/US/females/chianti/img_2.jpg": 35997,
	"./images/champions/US/females/chianti/img_3.jpg": 78683,
	"./images/champions/US/females/chianti/img_4.jpg": 70801,
	"./images/champions/US/females/chianti/img_5.jpg": 78700,
	"./images/champions/US/females/chianti/img_6.jpg": 78025,
	"./images/champions/US/females/chianti/img_7.jpg": 4275,
	"./images/champions/US/females/chianti/img_8.jpg": 41514,
	"./images/champions/US/females/chianti/img_9.jpg": 71519,
	"./images/champions/US/females/shiraz/img_1.jpg": 37812,
	"./images/champions/US/females/shiraz/img_2.jpg": 50636,
	"./images/champions/US/females/shiraz/img_3.jpg": 24313,
	"./images/champions/US/females/shiraz/img_4.jpg": 58540,
	"./images/champions/US/females/shiraz/img_5.jpg": 77272,
	"./images/champions/US/females/shiraz/img_6.jpg": 77558,
	"./images/champions/US/females/shiraz/old/img_1.png": 16089,
	"./images/champions/US/females/shiraz/old/img_10.png": 57685,
	"./images/champions/US/females/shiraz/old/img_11.png": 79740,
	"./images/champions/US/females/shiraz/old/img_12.png": 85566,
	"./images/champions/US/females/shiraz/old/img_13.png": 43377,
	"./images/champions/US/females/shiraz/old/img_14.png": 92052,
	"./images/champions/US/females/shiraz/old/img_15.png": 29053,
	"./images/champions/US/females/shiraz/old/img_16.png": 76349,
	"./images/champions/US/females/shiraz/old/img_17.png": 2602,
	"./images/champions/US/females/shiraz/old/img_2.png": 24662,
	"./images/champions/US/females/shiraz/old/img_3.png": 76585,
	"./images/champions/US/females/shiraz/old/img_4.png": 83354,
	"./images/champions/US/females/shiraz/old/img_5.png": 15301,
	"./images/champions/US/females/shiraz/old/img_6.png": 51319,
	"./images/champions/US/females/shiraz/old/img_7.png": 55775,
	"./images/champions/US/females/shiraz/old/img_8.png": 56908,
	"./images/champions/US/females/shiraz/old/img_9.png": 91121,
	"./images/champions/US/males/baldwin/img_1.jpeg": 25151,
	"./images/champions/US/males/baldwin/img_2.jpeg": 31236,
	"./images/champions/US/males/dante/img_1.png": 55204,
	"./images/champions/US/males/dante/img_2.png": 29177,
	"./images/champions/US/males/dante/img_3.png": 52926,
	"./images/champions/US/males/dante/img_4.png": 1064,
	"./images/champions/US/males/img_1.png": 42375,
	"./images/champions/US/males/img_2.png": 55184,
	"./images/champions/US/males/img_3.png": 99219,
	"./images/champions/US/males/img_4.png": 69976,
	"./images/champions/US/males/norbi/img_1.png": 79563,
	"./images/champions/US/males/norbi/img_2.png": 42545,
	"./images/champions/US/males/norbi/img_3.png": 30792,
	"./images/champions/US/males/norbi/img_4.png": 96285,
	"./images/champions/US/males/norbi/img_5.png": 83659,
	"./images/champions/US/males/norbi/img_6.png": 98482,
	"./images/champions/US/males/norbi/img_7.png": 90942,
	"./images/champions/US/males/norbi/img_8.png": 24262,
	"./images/champions/US/males/norbi/img_9.png": 76111,
	"./images/champions/US/retired/indie/img_1.png": 60799,
	"./images/champions/US/retired/indie/img_2.png": 21945,
	"./images/champions/US/retired/indie/img_3.png": 85356,
	"./images/champions/US/retired/indie/img_4.png": 60895,
	"./images/champions/US/retired/indie/img_5.png": 88281,
	"./images/champions/US/retired/indie/img_6.png": 50878,
	"./images/champions/US/retired/merlot/img_1.jpg": 4336,
	"./images/champions/US/retired/merlot/img_10.jpg": 69154,
	"./images/champions/US/retired/merlot/img_11.jpg": 43035,
	"./images/champions/US/retired/merlot/img_12.jpg": 87218,
	"./images/champions/US/retired/merlot/img_13.jpg": 24841,
	"./images/champions/US/retired/merlot/img_14.jpg": 2744,
	"./images/champions/US/retired/merlot/img_15.jpg": 35666,
	"./images/champions/US/retired/merlot/img_16.jpg": 86682,
	"./images/champions/US/retired/merlot/img_17.jpg": 1318,
	"./images/champions/US/retired/merlot/img_18.jpg": 46202,
	"./images/champions/US/retired/merlot/img_18.png": 39574,
	"./images/champions/US/retired/merlot/img_19.jpg": 99473,
	"./images/champions/US/retired/merlot/img_2.jpg": 45322,
	"./images/champions/US/retired/merlot/img_20.jpg": 24799,
	"./images/champions/US/retired/merlot/img_21.jpg": 87440,
	"./images/champions/US/retired/merlot/img_22.jpg": 5317,
	"./images/champions/US/retired/merlot/img_23.jpg": 52897,
	"./images/champions/US/retired/merlot/img_24.jpg": 52589,
	"./images/champions/US/retired/merlot/img_25.jpg": 81587,
	"./images/champions/US/retired/merlot/img_26.jpg": 38164,
	"./images/champions/US/retired/merlot/img_27.jpg": 90767,
	"./images/champions/US/retired/merlot/img_27.png": 5605,
	"./images/champions/US/retired/merlot/img_28.jpg": 89036,
	"./images/champions/US/retired/merlot/img_29.jpg": 99563,
	"./images/champions/US/retired/merlot/img_3.jpg": 22112,
	"./images/champions/US/retired/merlot/img_30.jpg": 11522,
	"./images/champions/US/retired/merlot/img_31.jpg": 39548,
	"./images/champions/US/retired/merlot/img_32.jpg": 34718,
	"./images/champions/US/retired/merlot/img_33.jpg": 56806,
	"./images/champions/US/retired/merlot/img_33.png": 87639,
	"./images/champions/US/retired/merlot/img_34.jpg": 86482,
	"./images/champions/US/retired/merlot/img_35.jpg": 44038,
	"./images/champions/US/retired/merlot/img_36.jpg": 15132,
	"./images/champions/US/retired/merlot/img_37.jpg": 55110,
	"./images/champions/US/retired/merlot/img_38.jpg": 51872,
	"./images/champions/US/retired/merlot/img_39.jpg": 3338,
	"./images/champions/US/retired/merlot/img_4.jpg": 25416,
	"./images/champions/US/retired/merlot/img_40.jpg": 573,
	"./images/champions/US/retired/merlot/img_41.jpg": 52162,
	"./images/champions/US/retired/merlot/img_42.jpg": 6518,
	"./images/champions/US/retired/merlot/img_43.jpg": 46921,
	"./images/champions/US/retired/merlot/img_44.jpg": 46859,
	"./images/champions/US/retired/merlot/img_45.jpg": 40039,
	"./images/champions/US/retired/merlot/img_46.jpg": 45767,
	"./images/champions/US/retired/merlot/img_47.jpg": 23512,
	"./images/champions/US/retired/merlot/img_48.jpg": 5790,
	"./images/champions/US/retired/merlot/img_49.jpg": 4546,
	"./images/champions/US/retired/merlot/img_5.jpg": 57271,
	"./images/champions/US/retired/merlot/img_50.jpg": 37241,
	"./images/champions/US/retired/merlot/img_6.jpg": 15722,
	"./images/champions/US/retired/merlot/img_7.jpg": 34418,
	"./images/champions/US/retired/merlot/img_8.jpg": 32513,
	"./images/champions/US/retired/merlot/img_9.jpg": 94390,
	"./images/champions/US/retired/piper/img_1.jpeg": 13312,
	"./images/champions/US/retired/piper/img_2.jpeg": 75476,
	"./images/champions/US/retired/piper/img_3.jpeg": 35963,
	"./images/champions/US/retired/piper/img_4.jpeg": 59614,
	"./images/champions/US/retired/vivi/img_1.png": 14961,
	"./images/champions/US/retired/vivi/img_2.png": 29321,
	"./images/champions/US/retired/vivi/img_3.png": 14152,
	"./images/champions/US/retired/vivi/img_4.png": 27619,
	"./images/champions/US/retired/vivi/img_5.png": 36298,
	"./images/champions/US/retired/vivi/img_6.png": 7073,
	"./images/champions/US/retired/vivi/img_7.png": 20387,
	"./images/champions/angels.png": 4954,
	"./images/champions/champion_trophies.png": 31761,
	"./images/champions/champions.png": 31587,
	"./images/champions/champions1.png": 59462,
	"./images/champions/females.png": 32898,
	"./images/champions/males.png": 85031,
	"./images/champions/retired.png": 5809,
	"./images/close-left-arrow.png": 80915,
	"./images/contact.png": 97812,
	"./images/contract_KPO-MBA_11278 LAICU HAUSBERGER ALEXANDRA GABRIELA copy.pdf": 94855,
	"./images/dangerous-foods.png": 59062,
	"./images/danube.webp": 29876,
	"./images/dummies.png": 73335,
	"./images/emergency-kit.png": 74546,
	"./images/favicon.ico": 69016,
	"./images/females.png": 98789,
	"./images/females.webp": 15171,
	"./images/footer-nr.png": 18476,
	"./images/footer_logo.png": 42041,
	"./images/gallery/2007/1/img_1.jpg": 38943,
	"./images/gallery/2007/1/img_10.jpg": 79153,
	"./images/gallery/2007/1/img_2.jpg": 34130,
	"./images/gallery/2007/1/img_3.jpg": 59948,
	"./images/gallery/2007/1/img_4.jpg": 773,
	"./images/gallery/2007/1/img_5.jpg": 17979,
	"./images/gallery/2007/1/img_6.jpg": 2825,
	"./images/gallery/2007/1/img_7.jpg": 51101,
	"./images/gallery/2007/1/img_8.jpg": 42792,
	"./images/gallery/2007/1/img_9.jpg": 39719,
	"./images/gallery/2007/2/img_1.jpg": 59794,
	"./images/gallery/2007/2/img_2.jpg": 21754,
	"./images/gallery/2007/2/img_3.jpg": 62615,
	"./images/gallery/2007/2/img_4.jpg": 75871,
	"./images/gallery/2007/2/img_5.jpg": 60917,
	"./images/gallery/2007/3/img_1.jpg": 42520,
	"./images/gallery/2007/3/img_2.jpg": 68525,
	"./images/gallery/2007/3/img_3.jpg": 91923,
	"./images/gallery/2007/4/img_1.jpg": 25034,
	"./images/gallery/2007/4/img_2.jpg": 44557,
	"./images/gallery/2007/5/img_1.jpg": 81242,
	"./images/gallery/2007/5/img_2.jpg": 9904,
	"./images/gallery/2007/5/img_3.jpg": 1217,
	"./images/gallery/2007/5/img_4.jpg": 43314,
	"./images/gallery/2007/5/img_5.jpg": 49044,
	"./images/gallery/2007/5/img_6.jpg": 71992,
	"./images/gallery/2007/5/img_7.jpg": 86029,
	"./images/gallery/2008/1/img_1.jpg": 64100,
	"./images/gallery/2008/1/img_2.jpg": 94581,
	"./images/gallery/2008/1/img_3.jpg": 86068,
	"./images/gallery/2008/2/img_1.jpg": 772,
	"./images/gallery/2008/2/img_2.jpg": 78319,
	"./images/gallery/2008/2/img_3.jpg": 51793,
	"./images/gallery/2008/2/img_4.jpg": 18395,
	"./images/gallery/2008/3/img_1.jpg": 38388,
	"./images/gallery/2008/3/img_2.jpg": 29756,
	"./images/gallery/2008/3/img_3.jpg": 26247,
	"./images/gallery/2008/3/img_4.jpg": 34164,
	"./images/gallery/2008/3/img_5.jpg": 56958,
	"./images/gallery/2008/4/img_1.jpg": 98913,
	"./images/gallery/2008/4/img_2.jpg": 19184,
	"./images/gallery/2008/4/img_3.jpg": 94616,
	"./images/gallery/2008/4/img_4.jpg": 319,
	"./images/gallery/2008/4/img_5.jpg": 1723,
	"./images/gallery/2008/4/img_6.jpg": 14936,
	"./images/gallery/2009/img_1.jpg": 51800,
	"./images/gallery/2009/img_2.jpg": 55812,
	"./images/gallery/2009/img_3.jpg": 65226,
	"./images/gallery/2009/img_4.png": 51439,
	"./images/gallery/2009/img_5.jpg": 94586,
	"./images/gallery/2009/img_6.jpg": 67478,
	"./images/gallery/2010/1/img_1.jpg": 1812,
	"./images/gallery/2010/1/img_2.jpg": 48998,
	"./images/gallery/2010/1/img_3.jpg": 61801,
	"./images/gallery/2010/2/img_1.jpg": 30402,
	"./images/gallery/2010/2/img_2.jpg": 25120,
	"./images/gallery/2010/2/img_3.jpg": 75677,
	"./images/gallery/2010/2/img_4.jpg": 88644,
	"./images/gallery/2010/3/img_1.jpg": 88036,
	"./images/gallery/2010/3/img_2.jpg": 75616,
	"./images/gallery/2010/3/img_3.jpg": 56679,
	"./images/gallery/2010/3/img_4.jpg": 85225,
	"./images/gallery/2010/4/img_1.jpg": 44418,
	"./images/gallery/2010/4/img_2.jpg": 82221,
	"./images/gallery/2010/4/img_3.jpg": 91828,
	"./images/gallery/2010/4/img_4.jpg": 87599,
	"./images/gallery/2010/5/img_1.jpg": 42197,
	"./images/gallery/2010/5/img_2.jpg": 4891,
	"./images/gallery/2011/img_1.jpg": 93605,
	"./images/gallery/2011/img_2.jpg": 49512,
	"./images/gallery/2011/img_3.jpg": 14320,
	"./images/gallery/2011/img_4.jpg": 76014,
	"./images/gallery/2011/img_5.jpg": 36636,
	"./images/gallery/2011/img_6.jpg": 61281,
	"./images/gallery/2011/img_7.jpg": 68948,
	"./images/gallery/2011/img_8.jpg": 62675,
	"./images/gallery/2012/1/img_1.jpg": 19344,
	"./images/gallery/2012/1/img_2.jpg": 16581,
	"./images/gallery/2012/1/img_3.jpg": 75452,
	"./images/gallery/2012/1/img_4.jpg": 39645,
	"./images/gallery/2012/1/img_5.jpg": 36569,
	"./images/gallery/2012/1/img_6.jpg": 5150,
	"./images/gallery/2012/1/img_7.jpg": 4256,
	"./images/gallery/2012/1/img_8.jpg": 77106,
	"./images/gallery/2012/1/img_9.jpg": 32745,
	"./images/gallery/2012/2/img_1.jpg": 70078,
	"./images/gallery/2012/2/img_2.jpg": 40088,
	"./images/gallery/2012/3/img_1.jpg": 49871,
	"./images/gallery/2012/3/img_2.jpg": 73188,
	"./images/gallery/2012/3/img_3.jpg": 28336,
	"./images/gallery/2012/4/img_1.jpg": 52736,
	"./images/gallery/2012/4/img_2.jpg": 6705,
	"./images/gallery/2013/1/img_1.jpg": 49583,
	"./images/gallery/2013/1/img_2.jpg": 40168,
	"./images/gallery/2013/1/img_3.jpg": 26693,
	"./images/gallery/2013/1/img_4.jpg": 68868,
	"./images/gallery/2013/2/img_1.jpg": 35232,
	"./images/gallery/2013/2/img_2.jpg": 94805,
	"./images/gallery/2013/3/img_1.jpg": 38373,
	"./images/gallery/2013/3/img_2.jpg": 86564,
	"./images/gallery/2013/4/img_1.png": 66052,
	"./images/gallery/2014/1/img_1.jpg": 41630,
	"./images/gallery/2014/1/img_2.jpg": 18185,
	"./images/gallery/2014/1/img_3.jpg": 88098,
	"./images/gallery/2014/1/img_4.jpg": 20506,
	"./images/gallery/2014/2/img_1.jpg": 49039,
	"./images/gallery/2014/2/img_2.jpg": 37483,
	"./images/gallery/2014/2/img_3.jpg": 23431,
	"./images/gallery/2014/2/img_4.jpg": 68238,
	"./images/gallery/2014/2/img_5.jpg": 98154,
	"./images/gallery/2014/2/img_6.jpg": 29117,
	"./images/gallery/2014/2/img_7.jpg": 74128,
	"./images/gallery/2014/2/img_8.jpg": 89899,
	"./images/gallery/2014/3/img_1.jpg": 93759,
	"./images/gallery/2014/3/img_2.jpg": 68592,
	"./images/gallery/2014/3/img_3.jpg": 14820,
	"./images/gallery/2014/3/img_4.jpg": 43777,
	"./images/gallery/2014/4/img_1.jpg": 61163,
	"./images/gallery/2014/4/img_2.jpg": 67470,
	"./images/gallery/2014/4/img_3.jpg": 35406,
	"./images/gallery/2014/4/img_4.jpg": 46686,
	"./images/gallery/2015/1/img_1.jpg": 7834,
	"./images/gallery/2015/1/img_2.jpg": 78263,
	"./images/gallery/2015/1/img_3.jpg": 14515,
	"./images/gallery/2015/2/img_1.jpg": 13907,
	"./images/gallery/2015/2/img_2.jpg": 37331,
	"./images/gallery/2015/3/img_1.jpg": 29813,
	"./images/gallery/2015/3/img_10.jpg": 52986,
	"./images/gallery/2015/3/img_11.jpg": 51754,
	"./images/gallery/2015/3/img_2.jpg": 18915,
	"./images/gallery/2015/3/img_3.jpg": 54132,
	"./images/gallery/2015/3/img_4.jpg": 56674,
	"./images/gallery/2015/3/img_5.jpg": 53890,
	"./images/gallery/2015/3/img_6.jpg": 40376,
	"./images/gallery/2015/3/img_7.jpg": 40674,
	"./images/gallery/2015/3/img_8.jpg": 43496,
	"./images/gallery/2015/3/img_9.png": 91781,
	"./images/gallery/2015/4/img_1.jpg": 94765,
	"./images/gallery/2015/4/img_2.jpg": 43143,
	"./images/gallery/2015/4/img_3.jpg": 74959,
	"./images/gallery/2015/4/img_4.jpg": 45476,
	"./images/gallery/2015/4/img_5.jpg": 24345,
	"./images/gallery/2015/5/img_1.jpg": 57665,
	"./images/gallery/2015/5/img_2.jpg": 98739,
	"./images/gallery/2015/5/img_3.jpg": 12865,
	"./images/gallery/2015/5/img_4.jpg": 84513,
	"./images/gallery/2015/5/img_5.jpg": 90632,
	"./images/gallery/2015/6/img_1.jpg": 67810,
	"./images/gallery/2015/6/img_2.jpg": 49379,
	"./images/gallery/2015/6/img_3.jpg": 31931,
	"./images/gallery/2015/6/img_4.jpg": 23893,
	"./images/gallery/2015/6/img_5.jpg": 9373,
	"./images/gallery/2015/7/img_1.jpg": 94058,
	"./images/gallery/2015/7/img_2.png": 20177,
	"./images/gallery/2015/7/img_3.png": 69648,
	"./images/gallery/2015/7/img_4.png": 98120,
	"./images/gallery/2015/7/img_5.jpg": 16144,
	"./images/gallery/2015/7/img_6.jpg": 12769,
	"./images/gallery/2016/1/img_1.jpg": 84697,
	"./images/gallery/2016/1/img_2.jpg": 27682,
	"./images/gallery/2016/1/img_3.jpg": 87999,
	"./images/gallery/2016/1/img_4.jpg": 17081,
	"./images/gallery/2016/1/img_5.jpg": 75748,
	"./images/gallery/2016/2/img_1.jpg": 88942,
	"./images/gallery/2016/2/img_2.jpg": 90353,
	"./images/gallery/2016/2/img_3.jpg": 82258,
	"./images/gallery/2016/2/img_4.jpg": 46235,
	"./images/gallery/2016/2/img_5.jpg": 70651,
	"./images/gallery/2016/2/img_6.png": 57907,
	"./images/gallery/2016/3/img_1.jpg": 99584,
	"./images/gallery/2016/3/img_2.jpg": 9678,
	"./images/gallery/2016/3/img_3.jpg": 55763,
	"./images/gallery/2016/3/img_4.jpg": 84420,
	"./images/gallery/2016/4/img_1.jpg": 77888,
	"./images/gallery/2016/4/img_2.jpg": 49558,
	"./images/gallery/2016/5/img_1.jpg": 71694,
	"./images/gallery/2016/5/img_2.jpg": 87591,
	"./images/gallery/2016/5/img_3.jpg": 99671,
	"./images/gallery/2016/6/img_1.jpg": 55807,
	"./images/gallery/2016/6/img_2.jpg": 54022,
	"./images/gallery/2016/6/img_3.jpg": 80877,
	"./images/gallery/2016/6/img_4.jpg": 67973,
	"./images/gallery/2016/6/img_5.jpg": 76515,
	"./images/gallery/2017/1/img_1.png": 81112,
	"./images/gallery/2017/1/img_2.jpg": 82441,
	"./images/gallery/2017/1/img_3.jpg": 43339,
	"./images/gallery/2017/1/img_4.png": 48884,
	"./images/gallery/2017/1/img_5.png": 43825,
	"./images/gallery/2017/10/img_1.jpg": 76101,
	"./images/gallery/2017/10/img_2.jpg": 67801,
	"./images/gallery/2017/10/img_3.jpg": 43802,
	"./images/gallery/2017/10/img_4.jpg": 32396,
	"./images/gallery/2017/10/img_5.jpg": 32731,
	"./images/gallery/2017/10/img_6.jpg": 61332,
	"./images/gallery/2017/10/img_7.jpg": 79439,
	"./images/gallery/2017/11/img_1.jpg": 96963,
	"./images/gallery/2017/11/img_10.jpg": 55443,
	"./images/gallery/2017/11/img_11.jpg": 67293,
	"./images/gallery/2017/11/img_12.jpg": 29327,
	"./images/gallery/2017/11/img_2.png": 88738,
	"./images/gallery/2017/11/img_3.jpg": 79254,
	"./images/gallery/2017/11/img_4.jpg": 89180,
	"./images/gallery/2017/11/img_5.jpg": 53735,
	"./images/gallery/2017/11/img_6.jpg": 43973,
	"./images/gallery/2017/11/img_7.jpg": 30774,
	"./images/gallery/2017/11/img_8.jpg": 44387,
	"./images/gallery/2017/11/img_9.jpg": 58766,
	"./images/gallery/2017/12/img_1.jpg": 72298,
	"./images/gallery/2017/12/img_10.jpg": 61779,
	"./images/gallery/2017/12/img_2.png": 73363,
	"./images/gallery/2017/12/img_3.png": 68350,
	"./images/gallery/2017/12/img_4.jpg": 35366,
	"./images/gallery/2017/12/img_5.jpg": 17422,
	"./images/gallery/2017/12/img_6.jpg": 59643,
	"./images/gallery/2017/12/img_7.png": 14638,
	"./images/gallery/2017/12/img_8.jpg": 17182,
	"./images/gallery/2017/12/img_9.jpg": 62400,
	"./images/gallery/2017/13/img_1.jpg": 70901,
	"./images/gallery/2017/13/img_2.jpg": 79364,
	"./images/gallery/2017/13/img_3.jpg": 26352,
	"./images/gallery/2017/13/img_4.jpg": 84457,
	"./images/gallery/2017/13/img_5.jpg": 26714,
	"./images/gallery/2017/13/img_6.png": 69873,
	"./images/gallery/2017/14/img_1.jpg": 96173,
	"./images/gallery/2017/2/img_1.png": 90260,
	"./images/gallery/2017/2/img_2.jpg": 87509,
	"./images/gallery/2017/2/img_3.jpg": 12119,
	"./images/gallery/2017/2/img_4.jpg": 66829,
	"./images/gallery/2017/3/img_1.jpg": 21342,
	"./images/gallery/2017/3/img_10.jpg": 42875,
	"./images/gallery/2017/3/img_2.jpg": 95247,
	"./images/gallery/2017/3/img_3.jpg": 57989,
	"./images/gallery/2017/3/img_4.jpg": 62873,
	"./images/gallery/2017/3/img_5.jpg": 18092,
	"./images/gallery/2017/3/img_6.jpg": 60899,
	"./images/gallery/2017/3/img_7.jpg": 14608,
	"./images/gallery/2017/3/img_8.jpg": 51569,
	"./images/gallery/2017/3/img_9.jpg": 19007,
	"./images/gallery/2017/4/img_1.jpg": 29949,
	"./images/gallery/2017/4/img_10.jpg": 35205,
	"./images/gallery/2017/4/img_11.jpg": 47088,
	"./images/gallery/2017/4/img_12.jpg": 6600,
	"./images/gallery/2017/4/img_2.jpg": 85523,
	"./images/gallery/2017/4/img_3.jpg": 78745,
	"./images/gallery/2017/4/img_4.jpg": 20661,
	"./images/gallery/2017/4/img_5.jpg": 45823,
	"./images/gallery/2017/4/img_6.jpg": 84079,
	"./images/gallery/2017/4/img_7.jpg": 69300,
	"./images/gallery/2017/4/img_8.jpg": 71040,
	"./images/gallery/2017/4/img_9.jpg": 89795,
	"./images/gallery/2017/5/img_1.jpg": 52698,
	"./images/gallery/2017/5/img_2.jpg": 48963,
	"./images/gallery/2017/5/img_3.jpg": 36072,
	"./images/gallery/2017/6/img_1.jpg": 43932,
	"./images/gallery/2017/6/img_2.jpg": 4573,
	"./images/gallery/2017/6/img_3.jpg": 72698,
	"./images/gallery/2017/7/img_1.jpg": 87919,
	"./images/gallery/2017/7/img_2.jpg": 79180,
	"./images/gallery/2017/8/img_1.png": 98646,
	"./images/gallery/2017/8/img_2.png": 47696,
	"./images/gallery/2017/8/img_3.png": 17815,
	"./images/gallery/2017/9/img_1.jpg": 33434,
	"./images/gallery/2017/9/img_2.jpg": 29601,
	"./images/gallery/2017/9/img_3.jpg": 79379,
	"./images/gallery/2017/9/img_4.jpg": 67154,
	"./images/gallery/2017/9/img_5.jpg": 5209,
	"./images/gallery/2018/1/img_1.png": 28190,
	"./images/gallery/2018/1/img_2.jpg": 70398,
	"./images/gallery/2018/1/img_3.png": 2612,
	"./images/gallery/2018/1/img_4.png": 24862,
	"./images/gallery/2018/1/img_5.png": 90959,
	"./images/gallery/2018/2/img_1.jpg": 67118,
	"./images/gallery/2018/2/img_2.jpg": 8651,
	"./images/gallery/2018/2/img_3.jpg": 75948,
	"./images/gallery/2018/2/img_4.jpg": 17486,
	"./images/gallery/2018/2/img_5.jpg": 18388,
	"./images/gallery/2018/2/img_6.jpg": 5084,
	"./images/gallery/2018/2/img_7.jpg": 6197,
	"./images/gallery/2018/3/img_1.jpg": 40612,
	"./images/gallery/2018/3/img_2.jpg": 22316,
	"./images/gallery/2018/3/img_3.jpg": 774,
	"./images/gallery/2018/3/img_4.jpg": 14803,
	"./images/gallery/2018/4/img_1.jpg": 46027,
	"./images/gallery/2018/4/img_2.jpg": 8124,
	"./images/gallery/2018/5/img_1.jpg": 47258,
	"./images/gallery/2018/5/img_2.jpg": 96317,
	"./images/gallery/2018/5/img_3.jpg": 45837,
	"./images/gallery/2018/5/img_4.jpg": 5034,
	"./images/gallery/2018/5/img_5.jpg": 54853,
	"./images/gallery/2018/6/img_1.jpg": 99590,
	"./images/gallery/2018/6/img_2.jpg": 62690,
	"./images/gallery/2018/6/img_3.jpg": 8302,
	"./images/gallery/2018/6/img_4.jpg": 34905,
	"./images/gallery/2018/6/img_5.jpg": 70343,
	"./images/gallery/2018/6/img_6.jpg": 65189,
	"./images/gallery/2018/6/img_7.jpg": 44720,
	"./images/gallery/2018/7/img_1.jpg": 3926,
	"./images/gallery/2018/7/img_2.jpg": 85268,
	"./images/gallery/2018/7/img_3.jpg": 6923,
	"./images/gallery/2018/7/img_4.jpg": 79642,
	"./images/gallery/2018/7/img_5.jpg": 34359,
	"./images/gallery/2018/7/img_6.jpg": 84341,
	"./images/gallery/2018/7/img_7.jpg": 16402,
	"./images/gallery/2018/7/img_8.jpg": 72464,
	"./images/gallery/2019/1/img_1.jpg": 50328,
	"./images/gallery/2019/1/img_10.jpg": 83103,
	"./images/gallery/2019/1/img_11.jpg": 11729,
	"./images/gallery/2019/1/img_2.jpg": 14994,
	"./images/gallery/2019/1/img_3.jpg": 66684,
	"./images/gallery/2019/1/img_4.jpg": 94716,
	"./images/gallery/2019/1/img_5.jpg": 62894,
	"./images/gallery/2019/1/img_6.jpg": 42021,
	"./images/gallery/2019/1/img_7.jpg": 78630,
	"./images/gallery/2019/1/img_8.jpg": 45808,
	"./images/gallery/2019/1/img_9.jpg": 72628,
	"./images/gallery/2019/10/img_1.jpg": 40510,
	"./images/gallery/2019/10/img_2.jpg": 35513,
	"./images/gallery/2019/10/img_3.jpg": 24622,
	"./images/gallery/2019/10/img_4.jpg": 63392,
	"./images/gallery/2019/10/img_5.jpg": 66805,
	"./images/gallery/2019/11/img_1.jpg": 52430,
	"./images/gallery/2019/11/img_10.jpg": 45876,
	"./images/gallery/2019/11/img_2.jpg": 39215,
	"./images/gallery/2019/11/img_3.jpg": 3640,
	"./images/gallery/2019/11/img_4.jpg": 51296,
	"./images/gallery/2019/11/img_5.jpg": 57417,
	"./images/gallery/2019/11/img_6.jpg": 70214,
	"./images/gallery/2019/11/img_7.jpg": 62839,
	"./images/gallery/2019/11/img_8.jpg": 33174,
	"./images/gallery/2019/11/img_9.jpg": 68639,
	"./images/gallery/2019/12/img_1.jpg": 8937,
	"./images/gallery/2019/12/img_2.jpg": 52846,
	"./images/gallery/2019/12/img_3.jpg": 39541,
	"./images/gallery/2019/12/img_4.jpg": 26191,
	"./images/gallery/2019/12/img_5.jpg": 13768,
	"./images/gallery/2019/12/img_6.jpg": 95832,
	"./images/gallery/2019/2/img_1.jpg": 8465,
	"./images/gallery/2019/2/img_2.jpg": 64405,
	"./images/gallery/2019/2/img_3.jpg": 54297,
	"./images/gallery/2019/2/img_4.jpg": 23876,
	"./images/gallery/2019/2/img_5.jpg": 13883,
	"./images/gallery/2019/3/img_1.jpg": 52809,
	"./images/gallery/2019/3/img_2.jpg": 34086,
	"./images/gallery/2019/3/img_3.jpg": 97475,
	"./images/gallery/2019/4/img_1.jpg": 11131,
	"./images/gallery/2019/4/img_2.jpg": 50799,
	"./images/gallery/2019/4/img_3.jpg": 33807,
	"./images/gallery/2019/4/img_4.jpg": 11832,
	"./images/gallery/2019/4/img_5.jpg": 33000,
	"./images/gallery/2019/4/img_6.jpg": 70921,
	"./images/gallery/2019/5/img_1.jpg": 24750,
	"./images/gallery/2019/5/img_2.jpg": 88933,
	"./images/gallery/2019/5/img_3.jpg": 36056,
	"./images/gallery/2019/5/img_4.jpg": 12593,
	"./images/gallery/2019/5/img_5.jpg": 35278,
	"./images/gallery/2019/5/img_6.jpg": 57611,
	"./images/gallery/2019/5/img_7.jpg": 66779,
	"./images/gallery/2019/6/img_1.jpg": 89002,
	"./images/gallery/2019/6/img_2.jpg": 80890,
	"./images/gallery/2019/7/img_1.jpg": 73917,
	"./images/gallery/2019/8/img_1.jpg": 43615,
	"./images/gallery/2019/8/img_2.jpg": 38724,
	"./images/gallery/2019/8/img_3.jpg": 83921,
	"./images/gallery/2019/8/img_4.jpg": 46739,
	"./images/gallery/2019/8/img_5.jpg": 82988,
	"./images/gallery/2019/9/img_1.jpg": 76448,
	"./images/gallery/2019/9/img_10.jpg": 91969,
	"./images/gallery/2019/9/img_11.jpg": 36017,
	"./images/gallery/2019/9/img_2.jpg": 85533,
	"./images/gallery/2019/9/img_3.jpg": 99266,
	"./images/gallery/2019/9/img_4.jpg": 77598,
	"./images/gallery/2019/9/img_5.jpg": 67594,
	"./images/gallery/2019/9/img_6.jpg": 83407,
	"./images/gallery/2019/9/img_7.jpg": 40495,
	"./images/gallery/2019/9/img_8.jpg": 37973,
	"./images/gallery/2019/9/img_9.jpg": 98723,
	"./images/gallery/2020/1/img_1.jpg": 97826,
	"./images/gallery/2020/2/img_1.jpg": 85360,
	"./images/gallery/2020/2/img_2.jpg": 66315,
	"./images/gallery/2020/2/img_3.jpg": 45196,
	"./images/gallery/2020/2/img_4.jpg": 48402,
	"./images/gallery/2020/2/img_5.jpg": 38519,
	"./images/gallery/2020/2/img_6.jpg": 56154,
	"./images/gallery/2020/3/img_1.jpg": 2994,
	"./images/gallery/2020/3/img_2.jpg": 70243,
	"./images/gallery/2020/3/img_3.jpg": 42123,
	"./images/gallery/2020/3/img_4.jpg": 72321,
	"./images/gallery/2020/4/img_1.jpg": 36977,
	"./images/gallery/2020/4/img_2.jpg": 53434,
	"./images/gallery/2020/4/img_3.jpg": 71031,
	"./images/gallery/2020/4/img_4.jpg": 48095,
	"./images/gallery/2020/4/img_5.jpg": 9980,
	"./images/gallery/2020/4/img_6.jpg": 13315,
	"./images/gallery/2020/4/img_7.jpg": 25288,
	"./images/gallery/2020/4/img_8.jpg": 15901,
	"./images/gallery/2021/1/img_1.jpg": 4480,
	"./images/gallery/2021/10/img_1.jpg": 83186,
	"./images/gallery/2021/10/img_2.jpg": 97856,
	"./images/gallery/2021/11/img_1.jpg": 28207,
	"./images/gallery/2021/11/img_2.jpg": 13909,
	"./images/gallery/2021/11/img_3.jpg": 6335,
	"./images/gallery/2021/12/img_1.jpg": 21109,
	"./images/gallery/2021/12/img_2.jpg": 34560,
	"./images/gallery/2021/13/img_1.jpg": 21867,
	"./images/gallery/2021/13/img_2.jpg": 70779,
	"./images/gallery/2021/13/img_3.jpg": 46515,
	"./images/gallery/2021/13/img_4.jpg": 23919,
	"./images/gallery/2021/13/img_5.jpg": 11060,
	"./images/gallery/2021/13/img_6.jpg": 17832,
	"./images/gallery/2021/13/img_7.jpg": 80024,
	"./images/gallery/2021/13/img_8.jpg": 43800,
	"./images/gallery/2021/14/img_1.jpg": 24251,
	"./images/gallery/2021/14/img_2.jpg": 99436,
	"./images/gallery/2021/14/img_3.jpg": 89067,
	"./images/gallery/2021/14/img_4.jpg": 8940,
	"./images/gallery/2021/15/img_1.jpg": 90048,
	"./images/gallery/2021/15/img_2.jpg": 16589,
	"./images/gallery/2021/15/img_3.jpg": 11153,
	"./images/gallery/2021/15/img_4.jpg": 76347,
	"./images/gallery/2021/16/img_1.jpg": 91943,
	"./images/gallery/2021/16/img_2.jpg": 65824,
	"./images/gallery/2021/16/img_3.jpg": 45780,
	"./images/gallery/2021/16/img_4.jpg": 62524,
	"./images/gallery/2021/17/img_1.jpg": 83120,
	"./images/gallery/2021/17/img_2.jpg": 81770,
	"./images/gallery/2021/17/img_3.jpg": 23515,
	"./images/gallery/2021/17/img_4.jpg": 57410,
	"./images/gallery/2021/17/img_5.jpg": 76565,
	"./images/gallery/2021/17/img_6.jpg": 13684,
	"./images/gallery/2021/2/img_1.jpg": 75390,
	"./images/gallery/2021/2/img_2.jpg": 57688,
	"./images/gallery/2021/2/img_3.jpg": 72608,
	"./images/gallery/2021/2/img_4.jpg": 57605,
	"./images/gallery/2021/2/img_5.jpg": 81016,
	"./images/gallery/2021/3/img_1.jpg": 84875,
	"./images/gallery/2021/3/img_2.jpg": 12885,
	"./images/gallery/2021/3/img_3.jpg": 96654,
	"./images/gallery/2021/3/img_4.jpg": 53438,
	"./images/gallery/2021/4/img_1.jpg": 11094,
	"./images/gallery/2021/4/img_2.jpg": 78366,
	"./images/gallery/2021/5/img_1.jpg": 62882,
	"./images/gallery/2021/5/img_2.jpg": 95890,
	"./images/gallery/2021/5/img_3.jpg": 99361,
	"./images/gallery/2021/6/img_1.jpg": 3471,
	"./images/gallery/2021/6/img_10.jpg": 9188,
	"./images/gallery/2021/6/img_11.jpg": 64257,
	"./images/gallery/2021/6/img_2.jpg": 64642,
	"./images/gallery/2021/6/img_3.jpg": 95214,
	"./images/gallery/2021/6/img_4.jpg": 35551,
	"./images/gallery/2021/6/img_5.jpg": 14539,
	"./images/gallery/2021/6/img_6.jpg": 67609,
	"./images/gallery/2021/6/img_7.jpg": 97497,
	"./images/gallery/2021/6/img_8.jpg": 27311,
	"./images/gallery/2021/6/img_9.jpg": 1629,
	"./images/gallery/2021/7/img_1.jpg": 79031,
	"./images/gallery/2021/7/img_2.jpg": 41976,
	"./images/gallery/2021/7/img_3.jpg": 74985,
	"./images/gallery/2021/7/img_4.jpg": 91167,
	"./images/gallery/2021/7/img_5.jpg": 2553,
	"./images/gallery/2021/7/img_6.jpg": 12728,
	"./images/gallery/2021/8/img_1.jpg": 17531,
	"./images/gallery/2021/8/img_10.jpg": 37955,
	"./images/gallery/2021/8/img_2.jpg": 58554,
	"./images/gallery/2021/8/img_3.jpg": 92483,
	"./images/gallery/2021/8/img_4.jpg": 10131,
	"./images/gallery/2021/8/img_5.jpg": 11887,
	"./images/gallery/2021/8/img_6.jpg": 49483,
	"./images/gallery/2021/8/img_7.jpg": 58653,
	"./images/gallery/2021/8/img_8.jpg": 15763,
	"./images/gallery/2021/8/img_9.jpg": 7989,
	"./images/gallery/2021/9/img_1.jpg": 27893,
	"./images/gallery/2021/9/img_2.jpg": 11248,
	"./images/gallery/2021/9/img_3.jpg": 77876,
	"./images/gallery/2021/9/img_4.jpg": 15848,
	"./images/gallery/2021/9/img_5.jpg": 76481,
	"./images/gallery/2021/9/img_6.jpg": 79600,
	"./images/gallery/2021/9/img_7.jpg": 94212,
	"./images/gallery/2022/1/img_1.jpg": 53935,
	"./images/gallery/2022/1/img_2.jpg": 87323,
	"./images/gallery/2022/1/img_3.jpg": 45244,
	"./images/gallery/2022/1/img_4.jpg": 13162,
	"./images/gallery/2022/1/img_5.jpg": 45777,
	"./images/gallery/2022/1/img_6.jpg": 50744,
	"./images/gallery/2022/10/img_1.jpg": 63011,
	"./images/gallery/2022/10/img_2.jpg": 92485,
	"./images/gallery/2022/10/img_3.jpg": 36831,
	"./images/gallery/2022/10/img_4.jpg": 49889,
	"./images/gallery/2022/10/img_5.jpg": 15884,
	"./images/gallery/2022/11/img_1.jpg": 70676,
	"./images/gallery/2022/11/img_10.jpg": 36978,
	"./images/gallery/2022/11/img_11.jpg": 23648,
	"./images/gallery/2022/11/img_12.jpg": 80079,
	"./images/gallery/2022/11/img_13.jpg": 69027,
	"./images/gallery/2022/11/img_14.jpg": 71159,
	"./images/gallery/2022/11/img_15.jpg": 6663,
	"./images/gallery/2022/11/img_16.jpg": 14380,
	"./images/gallery/2022/11/img_2.jpg": 55789,
	"./images/gallery/2022/11/img_3.jpg": 30490,
	"./images/gallery/2022/11/img_4.jpg": 3341,
	"./images/gallery/2022/11/img_5.jpg": 82668,
	"./images/gallery/2022/11/img_6.jpg": 11310,
	"./images/gallery/2022/11/img_7.jpg": 23631,
	"./images/gallery/2022/11/img_8.jpg": 99337,
	"./images/gallery/2022/11/img_9.jpg": 4555,
	"./images/gallery/2022/12/img_1.jpg": 37059,
	"./images/gallery/2022/12/img_2.jpg": 66691,
	"./images/gallery/2022/12/img_3.jpg": 16773,
	"./images/gallery/2022/12/img_4.jpg": 58756,
	"./images/gallery/2022/13/img_1.jpg": 72910,
	"./images/gallery/2022/13/img_2.jpg": 30961,
	"./images/gallery/2022/13/img_3.jpg": 9136,
	"./images/gallery/2022/14/img_1.jpg": 46763,
	"./images/gallery/2022/14/img_2.jpg": 58624,
	"./images/gallery/2022/15/img_1.jpg": 99181,
	"./images/gallery/2022/15/img_2.jpg": 56117,
	"./images/gallery/2022/15/img_3.jpg": 80256,
	"./images/gallery/2022/16/img_1.jpg": 613,
	"./images/gallery/2022/16/img_2.jpg": 58705,
	"./images/gallery/2022/16/img_3.jpg": 97222,
	"./images/gallery/2022/16/img_4.jpg": 20274,
	"./images/gallery/2022/2/img_1.jpg": 2118,
	"./images/gallery/2022/2/img_2.jpg": 50453,
	"./images/gallery/2022/2/img_3.jpg": 74850,
	"./images/gallery/2022/2/img_4.jpg": 55255,
	"./images/gallery/2022/3/img_1.jpg": 84295,
	"./images/gallery/2022/3/img_2.jpg": 25722,
	"./images/gallery/2022/3/img_3.jpg": 93125,
	"./images/gallery/2022/3/img_4.jpg": 96248,
	"./images/gallery/2022/3/img_5.jpg": 91255,
	"./images/gallery/2022/3/img_6.jpg": 48630,
	"./images/gallery/2022/4/img_1.jpg": 77400,
	"./images/gallery/2022/4/img_2.jpg": 47465,
	"./images/gallery/2022/4/img_3.jpg": 9369,
	"./images/gallery/2022/4/img_4.jpg": 76024,
	"./images/gallery/2022/4/img_5.jpg": 2928,
	"./images/gallery/2022/5/img_1.jpg": 37683,
	"./images/gallery/2022/5/img_2.jpg": 89874,
	"./images/gallery/2022/5/img_3.jpg": 51139,
	"./images/gallery/2022/5/img_4.jpg": 46857,
	"./images/gallery/2022/5/img_5.jpg": 57632,
	"./images/gallery/2022/5/img_6.jpg": 80967,
	"./images/gallery/2022/6/img_1.jpg": 56446,
	"./images/gallery/2022/6/img_2.jpg": 45716,
	"./images/gallery/2022/7/img_1.jpg": 62758,
	"./images/gallery/2022/7/img_2.jpg": 34784,
	"./images/gallery/2022/7/img_3.jpg": 41974,
	"./images/gallery/2022/7/img_4.jpg": 3255,
	"./images/gallery/2022/7/img_5.jpg": 3387,
	"./images/gallery/2022/7/img_6.jpg": 11209,
	"./images/gallery/2022/7/img_7.jpg": 90319,
	"./images/gallery/2022/7/img_8.jpg": 44726,
	"./images/gallery/2022/8/img_1.jpg": 84406,
	"./images/gallery/2022/8/img_2.jpg": 38893,
	"./images/gallery/2022/8/img_3.jpg": 59046,
	"./images/gallery/2022/8/img_4.jpg": 77195,
	"./images/gallery/2022/9/img_1.jpg": 24807,
	"./images/gallery/2022/9/img_2.jpg": 30353,
	"./images/gallery/2022/9/img_3.jpg": 43880,
	"./images/gallery/2022/9/img_4.jpg": 78300,
	"./images/gallery/PCA 2019/1/img_1.jpg": 4557,
	"./images/gallery/PCA 2019/1/img_10.jpg": 2392,
	"./images/gallery/PCA 2019/1/img_11.jpg": 33810,
	"./images/gallery/PCA 2019/1/img_12.jpg": 15704,
	"./images/gallery/PCA 2019/1/img_13.jpg": 97821,
	"./images/gallery/PCA 2019/1/img_14.jpg": 62371,
	"./images/gallery/PCA 2019/1/img_15.jpg": 39836,
	"./images/gallery/PCA 2019/1/img_16.jpg": 58774,
	"./images/gallery/PCA 2019/1/img_17.jpg": 60815,
	"./images/gallery/PCA 2019/1/img_18.jpg": 51679,
	"./images/gallery/PCA 2019/1/img_19.jpg": 50197,
	"./images/gallery/PCA 2019/1/img_2.jpg": 52297,
	"./images/gallery/PCA 2019/1/img_20.jpg": 14654,
	"./images/gallery/PCA 2019/1/img_21.jpg": 7343,
	"./images/gallery/PCA 2019/1/img_22.png": 47859,
	"./images/gallery/PCA 2019/1/img_3.jpg": 4456,
	"./images/gallery/PCA 2019/1/img_4.jpg": 6924,
	"./images/gallery/PCA 2019/1/img_5.jpg": 32384,
	"./images/gallery/PCA 2019/1/img_6.jpg": 50153,
	"./images/gallery/PCA 2019/1/img_7.jpg": 60501,
	"./images/gallery/PCA 2019/1/img_8.jpg": 58168,
	"./images/gallery/PCA 2019/1/img_9.jpg": 65728,
	"./images/gallery/PCA 2019/2/img_1.jpg": 55152,
	"./images/gallery/PCA 2019/2/img_2.jpg": 89627,
	"./images/gallery/PCA 2019/3/img_1.jpg": 18532,
	"./images/gallery/PCA 2019/3/img_2.jpg": 4062,
	"./images/gallery/gallery-tiles/2017.png": 42258,
	"./images/gallery/gallery-tiles/2018.png": 49409,
	"./images/gallery/gallery-tiles/2019.png": 79660,
	"./images/gallery/gallery-tiles/2020.png": 20739,
	"./images/gallery/gallery-tiles/2021.jpg": 95418,
	"./images/gallery/gallery-tiles/2021.png": 50447,
	"./images/gallery/gallery-tiles/2022.jpg": 38145,
	"./images/gallery/gallery-tiles/2022.png": 57282,
	"./images/gallery/gallery-tiles/20222.png": 97317,
	"./images/gallery/gallery-tiles/more.jpg": 7227,
	"./images/gallery/gallery-tiles/more.png": 75793,
	"./images/gallery/main/1/img_1.png": 70018,
	"./images/gallery/main/1/img_2.jpg": 82150,
	"./images/gallery/main/10/img_1.png": 58591,
	"./images/gallery/main/10/img_2.png": 58976,
	"./images/gallery/main/10/img_3.png": 92366,
	"./images/gallery/main/11/img_1.png": 67866,
	"./images/gallery/main/11/img_2.jpg": 22520,
	"./images/gallery/main/11/img_3.png": 94089,
	"./images/gallery/main/11/img_4.jpg": 59809,
	"./images/gallery/main/2/img_1.jpg": 62245,
	"./images/gallery/main/2/img_2.jpg": 76496,
	"./images/gallery/main/2/img_3.jpg": 47186,
	"./images/gallery/main/2/img_4.jpg": 88765,
	"./images/gallery/main/2/img_5.jpg": 16426,
	"./images/gallery/main/3/img_1.jpg": 84983,
	"./images/gallery/main/3/img_2.jpg": 90832,
	"./images/gallery/main/4/img_1.jpg": 22179,
	"./images/gallery/main/5/img_1.jpg": 57477,
	"./images/gallery/main/5/img_2.jpg": 75273,
	"./images/gallery/main/5/img_3.jpg": 39459,
	"./images/gallery/main/5/img_4.jpg": 35710,
	"./images/gallery/main/5/img_5.jpg": 42855,
	"./images/gallery/main/5/img_6.jpg": 41726,
	"./images/gallery/main/5/img_7.jpg": 80119,
	"./images/gallery/main/5/img_8.jpg": 42540,
	"./images/gallery/main/5/img_9.jpg": 86362,
	"./images/gallery/main/6/img_1.jpg": 34939,
	"./images/gallery/main/6/img_2.jpg": 37351,
	"./images/gallery/main/7/img_1.jpg": 45265,
	"./images/gallery/main/7/img_2.jpg": 63138,
	"./images/gallery/main/7/img_3.jpg": 76820,
	"./images/gallery/main/8/img_1.jpg": 6413,
	"./images/gallery/main/8/img_2.jpg": 98402,
	"./images/gallery/main/8/img_3.jpg": 2147,
	"./images/gallery/main/8/img_4.png": 15536,
	"./images/gallery/main/8/img_5.png": 74477,
	"./images/gallery/main/9/img_1.png": 74393,
	"./images/gallery/main/9/img_2.png": 77595,
	"./images/gallery/main/9/img_3.png": 29144,
	"./images/healthProtocol/health_1.jpeg": 28701,
	"./images/healthProtocol/health_2.jpeg": 29958,
	"./images/healthProtocol/health_3.jpeg": 55962,
	"./images/healthProtocol/health_4.jpeg": 81165,
	"./images/healthProtocol/health_5.jpeg": 98632,
	"./images/healthProtocol/health_6.jpeg": 78950,
	"./images/healthProtocol/health_7.jpeg": 5939,
	"./images/healthProtocol/health_protocol3.png": 12913,
	"./images/healthProtocol/health_protocol4.png": 77393,
	"./images/health_protocol1.png": 47818,
	"./images/health_protocol2.png": 75541,
	"./images/hero.jpg": 42355,
	"./images/hero.png": 52141,
	"./images/hero1.jpg": 76995,
	"./images/hero1.png": 33053,
	"./images/hero2.jpg": 99759,
	"./images/hero2.png": 96447,
	"./images/hero3.png": 57910,
	"./images/hero4.jpg": 72947,
	"./images/hero_new.jpeg": 61324,
	"./images/home/logo-small.JPG": 46583,
	"./images/home/logo1.JPG": 40866,
	"./images/home/logo2.JPG": 59067,
	"./images/immuneSystem/1.jpeg": 32582,
	"./images/immuneSystem/2.jpeg": 52312,
	"./images/immuneSystem/3.jpeg": 2492,
	"./images/immuneSystem/4.jpeg": 65944,
	"./images/litter-plan/litter_plan_1.jpg": 88537,
	"./images/litter-plan/litter_plan_2.jpg": 30776,
	"./images/litter-plan/litter_plan_3.jpg": 86552,
	"./images/litter-plan/litter_plan_4.jpg": 9931,
	"./images/litter-plan/litter_plan_5.jpg": 70021,
	"./images/litter-plan/litter_plan_6.jpg": 59638,
	"./images/litter-plan/litter_plan_7.jpg": 32768,
	"./images/logo-transparent.png": 67333,
	"./images/logo.png": 96338,
	"./images/logo_new.jpg": 71924,
	"./images/magnetic.png": 87342,
	"./images/males.png": 99155,
	"./images/males.webp": 96950,
	"./images/medals.png": 5238,
	"./images/myStatement.png": 21334,
	"./images/natural_rearer.png": 93899,
	"./images/nav_left.png": 83737,
	"./images/nav_right.png": 30610,
	"./images/newLogos/img_1.png": 38639,
	"./images/newLogos/img_1.psd": 9350,
	"./images/newLogos/img_2.png": 37296,
	"./images/newLogos/img_2.psd": 28471,
	"./images/on_black_left.png": 51004,
	"./images/on_white_left.png": 45118,
	"./images/on_white_right.png": 35743,
	"./images/past-litters/mantras/mantra_1.png": 85528,
	"./images/past-litters/mantras/mantra_2.png": 65059,
	"./images/past-litters/past_litters_one_1": 90723,
	"./images/past-litters/past_litters_one_10": 13648,
	"./images/past-litters/past_litters_one_11": 8615,
	"./images/past-litters/past_litters_one_12": 7213,
	"./images/past-litters/past_litters_one_13": 52171,
	"./images/past-litters/past_litters_one_14": 22487,
	"./images/past-litters/past_litters_one_15": 67358,
	"./images/past-litters/past_litters_one_16": 29084,
	"./images/past-litters/past_litters_one_17": 52625,
	"./images/past-litters/past_litters_one_18": 87407,
	"./images/past-litters/past_litters_one_19": 9906,
	"./images/past-litters/past_litters_one_2": 89282,
	"./images/past-litters/past_litters_one_20": 15116,
	"./images/past-litters/past_litters_one_21": 27238,
	"./images/past-litters/past_litters_one_22": 87334,
	"./images/past-litters/past_litters_one_23": 30302,
	"./images/past-litters/past_litters_one_24": 2717,
	"./images/past-litters/past_litters_one_25": 88377,
	"./images/past-litters/past_litters_one_26": 77609,
	"./images/past-litters/past_litters_one_27": 74350,
	"./images/past-litters/past_litters_one_28": 63579,
	"./images/past-litters/past_litters_one_29": 94043,
	"./images/past-litters/past_litters_one_3": 86193,
	"./images/past-litters/past_litters_one_30": 74816,
	"./images/past-litters/past_litters_one_31": 9574,
	"./images/past-litters/past_litters_one_32": 53855,
	"./images/past-litters/past_litters_one_33": 6304,
	"./images/past-litters/past_litters_one_4": 11823,
	"./images/past-litters/past_litters_one_5": 73589,
	"./images/past-litters/past_litters_one_6": 45690,
	"./images/past-litters/past_litters_one_7": 5796,
	"./images/past-litters/past_litters_one_8": 40276,
	"./images/past-litters/past_litters_one_9": 86072,
	"./images/pastLitters.jpg": 99494,
	"./images/poisonous.png": 11969,
	"./images/quotes_image.png": 15322,
	"./images/safety-card.png": 9948,
	"./images/show_dog.png": 64002,
	"./images/store.webp": 4898,
	"./images/testimonials/page1/1/img_1.jpg": 52704,
	"./images/testimonials/page1/10/img_1.jpeg": 94317,
	"./images/testimonials/page1/10/img_2.jpg": 12793,
	"./images/testimonials/page1/10/img_3.jpg": 53327,
	"./images/testimonials/page1/10/img_4.jpg": 34162,
	"./images/testimonials/page1/10/img_5.jpeg": 94540,
	"./images/testimonials/page1/10/img_6.jpg": 29082,
	"./images/testimonials/page1/10/img_7.jpeg": 42028,
	"./images/testimonials/page1/10/img_8.jpg": 86876,
	"./images/testimonials/page1/11/img_1.png": 36437,
	"./images/testimonials/page1/11/img_2.jpg": 57421,
	"./images/testimonials/page1/11/img_3.jpg": 47766,
	"./images/testimonials/page1/11/img_4.jpg": 11288,
	"./images/testimonials/page1/11/img_5.png": 74831,
	"./images/testimonials/page1/11/img_6.jpg": 60441,
	"./images/testimonials/page1/11/img_7.png": 68413,
	"./images/testimonials/page1/12/img_1.jpg": 90648,
	"./images/testimonials/page1/12/img_2.jpg": 95625,
	"./images/testimonials/page1/12/img_3.jpg": 23211,
	"./images/testimonials/page1/12/img_4.jpg": 33900,
	"./images/testimonials/page1/12/img_5.jpg": 30798,
	"./images/testimonials/page1/12/img_6.jpg": 81768,
	"./images/testimonials/page1/12/img_7.jpg": 51880,
	"./images/testimonials/page1/13/img_1.jpg": 13018,
	"./images/testimonials/page1/13/img_2.jpg": 34330,
	"./images/testimonials/page1/13/img_3.jpg": 45146,
	"./images/testimonials/page1/13/img_4.jpg": 57652,
	"./images/testimonials/page1/13/img_5.jpg": 98729,
	"./images/testimonials/page1/13/img_6.jpg": 86570,
	"./images/testimonials/page1/13/img_7.jpg": 9604,
	"./images/testimonials/page1/13/img_8.jpg": 66996,
	"./images/testimonials/page1/14/img_1.jpg": 22186,
	"./images/testimonials/page1/14/img_2.jpg": 61071,
	"./images/testimonials/page1/14/img_3.jpg": 3076,
	"./images/testimonials/page1/14/img_4.jpg": 99287,
	"./images/testimonials/page1/14/img_5.jpg": 61509,
	"./images/testimonials/page1/14/img_6.jpg": 92659,
	"./images/testimonials/page1/14/img_7.jpg": 94653,
	"./images/testimonials/page1/14/img_8.jpg": 20267,
	"./images/testimonials/page1/14/img_9.jpg": 10730,
	"./images/testimonials/page1/15/img_1.jpg": 62996,
	"./images/testimonials/page1/15/img_2.jpg": 887,
	"./images/testimonials/page1/15/img_3.jpg": 20434,
	"./images/testimonials/page1/15/img_4.jpg": 56544,
	"./images/testimonials/page1/15/img_5.jpg": 88380,
	"./images/testimonials/page1/15/img_6.jpg": 64519,
	"./images/testimonials/page1/16/img_1.jpg": 59028,
	"./images/testimonials/page1/16/img_10.jpg": 63876,
	"./images/testimonials/page1/16/img_11.jpg": 87458,
	"./images/testimonials/page1/16/img_12.jpg": 63250,
	"./images/testimonials/page1/16/img_2.jpg": 47787,
	"./images/testimonials/page1/16/img_3.jpg": 26253,
	"./images/testimonials/page1/16/img_4.jpg": 36691,
	"./images/testimonials/page1/16/img_5.jpg": 19730,
	"./images/testimonials/page1/16/img_6.jpg": 37431,
	"./images/testimonials/page1/16/img_7.jpg": 94484,
	"./images/testimonials/page1/16/img_8.jpg": 22727,
	"./images/testimonials/page1/16/img_9.jpg": 64514,
	"./images/testimonials/page1/2/img_0.png": 2232,
	"./images/testimonials/page1/2/img_1.png": 5466,
	"./images/testimonials/page1/2/img_2.png": 71912,
	"./images/testimonials/page1/2/img_3.png": 97502,
	"./images/testimonials/page1/2/img_4.png": 19360,
	"./images/testimonials/page1/3/img_1.png": 33471,
	"./images/testimonials/page1/4/img_1.jpg": 12622,
	"./images/testimonials/page1/4/img_2.jpg": 60182,
	"./images/testimonials/page1/4/img_3.jpg": 99063,
	"./images/testimonials/page1/4/img_4.jpg": 8943,
	"./images/testimonials/page1/5/img_1.jpg": 81133,
	"./images/testimonials/page1/5/img_2.jpeg": 45839,
	"./images/testimonials/page1/6/img_1.jpg": 34140,
	"./images/testimonials/page1/6/img_2.jpg": 14132,
	"./images/testimonials/page1/6/img_3.jpg": 68779,
	"./images/testimonials/page1/6/img_4.jpg": 64818,
	"./images/testimonials/page1/6/img_5.jpg": 18514,
	"./images/testimonials/page1/6/img_6.jpg": 92268,
	"./images/testimonials/page1/7/img_1.jpg": 12369,
	"./images/testimonials/page1/7/img_2.jpg": 44952,
	"./images/testimonials/page1/7/img_3.jpg": 70434,
	"./images/testimonials/page1/7/img_4.png": 54895,
	"./images/testimonials/page1/7/img_5.jpg": 19303,
	"./images/testimonials/page1/8/img_1.jpg": 18373,
	"./images/testimonials/page1/8/img_2.jpeg": 89217,
	"./images/testimonials/page1/8/img_3.jpg": 47123,
	"./images/testimonials/page1/8/img_4.jpg": 99257,
	"./images/testimonials/page1/8/img_5.jpg": 85473,
	"./images/testimonials/page1/8/img_6.jpg": 4864,
	"./images/testimonials/page1/9/img_1.jpg": 18744,
	"./images/testimonials/page1/9/img_2.jpg": 5156,
	"./images/testimonials/page1/9/img_3.jpg": 79847,
	"./images/testimonials/page2/1/img_1.jpg": 5573,
	"./images/testimonials/page2/1/img_10.jpg": 33859,
	"./images/testimonials/page2/1/img_2.jpg": 54046,
	"./images/testimonials/page2/1/img_3.jpg": 81061,
	"./images/testimonials/page2/1/img_4.jpg": 46988,
	"./images/testimonials/page2/1/img_5.jpg": 52239,
	"./images/testimonials/page2/1/img_6.jpg": 9280,
	"./images/testimonials/page2/1/img_7.jpg": 17516,
	"./images/testimonials/page2/1/img_8.jpg": 38844,
	"./images/testimonials/page2/1/img_9.jpg": 60457,
	"./images/testimonials/page2/2/img_1.jpg": 28436,
	"./images/testimonials/page2/2/img_10.jpg": 20481,
	"./images/testimonials/page2/2/img_11.jpg": 81781,
	"./images/testimonials/page2/2/img_2.jpg": 41516,
	"./images/testimonials/page2/2/img_3.jpg": 85704,
	"./images/testimonials/page2/2/img_4.jpg": 56143,
	"./images/testimonials/page2/2/img_5.jpg": 46247,
	"./images/testimonials/page2/2/img_6.jpg": 39374,
	"./images/testimonials/page2/2/img_7.jpg": 26541,
	"./images/testimonials/page2/2/img_8.jpg": 59960,
	"./images/testimonials/page2/2/img_9.jpg": 66868,
	"./images/testimonials/page2/3/img_1.jpg": 46668,
	"./images/testimonials/page2/3/img_2.jpg": 66724,
	"./images/testimonials/page2/3/img_3.jpg": 59398,
	"./images/testimonials/page2/3/img_4.jpg": 19546,
	"./images/testimonials/page2/3/img_5.jpg": 63573,
	"./images/testimonials/page2/3/img_6.jpg": 83675,
	"./images/testimonials/page2/3/img_7.jpg": 9003,
	"./images/testimonials/page2/3/img_8.jpg": 25754,
	"./images/testimonials/page2/3/img_9.jpg": 77480,
	"./images/testimonials/page2/4/img_1.jpg": 98748,
	"./images/testimonials/page2/4/img_2.jpg": 108,
	"./images/testimonials/page2/4/img_3.jpg": 67298,
	"./images/testimonials/page2/4/img_4.jpg": 99587,
	"./images/testimonials/page2/4/img_5.jpg": 12568,
	"./images/testimonials/page2/4/img_6.jpg": 81516,
	"./images/testimonials/page2/4/img_7.jpg": 87441,
	"./images/testimonials/page2/4/img_8.jpg": 25013,
	"./images/testimonials/page2/4/img_9.jpg": 5964,
	"./images/testimonials/page3/1/img_1.jpg": 72387,
	"./images/testimonials/page3/1/img_2.jpg": 75702,
	"./images/testimonials/page3/1/img_3.jpg": 56161,
	"./images/testimonials/page3/2/img_1.jpg": 35039,
	"./images/testimonials/page3/2/img_10.png": 50645,
	"./images/testimonials/page3/2/img_11.jpg": 9713,
	"./images/testimonials/page3/2/img_12.jpg": 34265,
	"./images/testimonials/page3/2/img_13.png": 7122,
	"./images/testimonials/page3/2/img_2.jpg": 86460,
	"./images/testimonials/page3/2/img_3.jpg": 32501,
	"./images/testimonials/page3/2/img_4.jpg": 25520,
	"./images/testimonials/page3/2/img_5.png": 366,
	"./images/testimonials/page3/2/img_6.jpg": 88225,
	"./images/testimonials/page3/2/img_7.jpg": 78674,
	"./images/testimonials/page3/2/img_8.png": 1463,
	"./images/testimonials/page3/2/img_9.jpg": 51187,
	"./images/testimonials/page3/3/img_1.jpg": 90240,
	"./images/testimonials/page3/3/img_10.jpg": 59969,
	"./images/testimonials/page3/3/img_11.jpg": 4448,
	"./images/testimonials/page3/3/img_12.jpg": 42380,
	"./images/testimonials/page3/3/img_13.jpg": 86116,
	"./images/testimonials/page3/3/img_14.jpg": 38176,
	"./images/testimonials/page3/3/img_15.jpg": 25272,
	"./images/testimonials/page3/3/img_2.jpg": 87061,
	"./images/testimonials/page3/3/img_3.jpg": 10157,
	"./images/testimonials/page3/3/img_4.png": 68410,
	"./images/testimonials/page3/3/img_5.jpg": 96723,
	"./images/testimonials/page3/3/img_6.jpg": 97746,
	"./images/testimonials/page3/3/img_7.jpg": 49942,
	"./images/testimonials/page3/3/img_8.jpg": 39335,
	"./images/testimonials/page3/3/img_9.jpg": 81462,
	"./images/testimonials/page3/4/img_1.jpg": 3308,
	"./images/testimonials/page3/4/img_10.jpg": 47110,
	"./images/testimonials/page3/4/img_11.jpg": 93075,
	"./images/testimonials/page3/4/img_12.jpg": 51786,
	"./images/testimonials/page3/4/img_13.png": 48819,
	"./images/testimonials/page3/4/img_2.jpg": 64731,
	"./images/testimonials/page3/4/img_3.jpeg": 94411,
	"./images/testimonials/page3/4/img_4.jpg": 4255,
	"./images/testimonials/page3/4/img_5.jpg": 40721,
	"./images/testimonials/page3/4/img_6.jpg": 50327,
	"./images/testimonials/page3/4/img_7.jpg": 67490,
	"./images/testimonials/page3/4/img_8.jpg": 32993,
	"./images/testimonials/page3/4/img_9.jpg": 73664,
	"./images/testimonials/page3/5/img_1.jpg": 36852,
	"./images/testimonials/page3/5/img_10.jpg": 44790,
	"./images/testimonials/page3/5/img_11.jpg": 18064,
	"./images/testimonials/page3/5/img_12.png": 75231,
	"./images/testimonials/page3/5/img_13.jpg": 57427,
	"./images/testimonials/page3/5/img_14.jpg": 73074,
	"./images/testimonials/page3/5/img_2.jpg": 42236,
	"./images/testimonials/page3/5/img_3.jpg": 90943,
	"./images/testimonials/page3/5/img_4.jpg": 82752,
	"./images/testimonials/page3/5/img_5.jpg": 95808,
	"./images/testimonials/page3/5/img_6.jpg": 82077,
	"./images/testimonials/page3/5/img_7.jpg": 22674,
	"./images/testimonials/page3/5/img_8.png": 84466,
	"./images/testimonials/page3/5/img_9.jpg": 58670,
	"./images/testings/health1.png": 74931,
	"./images/testings/health2.png": 44825,
	"./images/testings/health3.png": 96113,
	"./images/testings/health4.png": 27588,
	"./images/testings/health5.png": 68763,
	"./images/testings/health6.png": 76691,
	"./images/values.jpg": 25546,
	"./images/white_wall.jpg": 9015,
	"./images/window-sticker.png": 55801,
	"./index": 64191,
	"./index.css": 51174,
	"./index.js": 64191,
	"./pages/AboutPage/AboutPage": 8643,
	"./pages/AboutPage/AboutPage.jsx": 8643,
	"./pages/AboutPage/GroomingPage/GroomingPage": 30030,
	"./pages/AboutPage/GroomingPage/GroomingPage.jsx": 30030,
	"./pages/AboutPage/HeavenPage/HeavenPage": 66709,
	"./pages/AboutPage/HeavenPage/HeavenPage.jsx": 66709,
	"./pages/AboutPage/MoreInfoPage/MoreInfoPage": 89778,
	"./pages/AboutPage/MoreInfoPage/MoreInfoPage.jsx": 89778,
	"./pages/AreYouReadyPages/AreYouReady/AreYouReady": 47747,
	"./pages/AreYouReadyPages/AreYouReady/AreYouReady.jsx": 47747,
	"./pages/AreYouReadyPages/BooksRecommendations/BooksRecommendations": 73793,
	"./pages/AreYouReadyPages/BooksRecommendations/BooksRecommendations.jsx": 73793,
	"./pages/AreYouReadyPages/GettingReady/GettingReady": 81230,
	"./pages/AreYouReadyPages/GettingReady/GettingReady.jsx": 81230,
	"./pages/AreYouReadyPages/NotAShowDog/NotAShowDog": 74714,
	"./pages/AreYouReadyPages/NotAShowDog/NotAShowDog.jsx": 74714,
	"./pages/Champions/ChampionsEU": 82355,
	"./pages/Champions/ChampionsEU.jsx": 82355,
	"./pages/Champions/ChampionsGallery/ChampionsGallery": 28443,
	"./pages/Champions/ChampionsGallery/ChampionsGallery.jsx": 28443,
	"./pages/Champions/ChampionsMain": 94860,
	"./pages/Champions/ChampionsMain.jsx": 94860,
	"./pages/Champions/ChampionsUS": 88867,
	"./pages/Champions/ChampionsUS.jsx": 88867,
	"./pages/Champions/EU/Autumn": 219,
	"./pages/Champions/EU/Autumn.jsx": 219,
	"./pages/Champions/EU/Females": 71074,
	"./pages/Champions/EU/Females.jsx": 71074,
	"./pages/Champions/EU/Retired": 22792,
	"./pages/Champions/EU/Retired.jsx": 22792,
	"./pages/Champions/US/AngelChampions": 8182,
	"./pages/Champions/US/AngelChampions.jsx": 8182,
	"./pages/Champions/US/ChampionsList/ChampionList": 11206,
	"./pages/Champions/US/ChampionsList/ChampionList.jsx": 11206,
	"./pages/Champions/US/FemalesChampions": 92982,
	"./pages/Champions/US/FemalesChampions.jsx": 92982,
	"./pages/Champions/US/MalesChampions": 82899,
	"./pages/Champions/US/MalesChampions.jsx": 82899,
	"./pages/Champions/US/RetiredChampions": 9104,
	"./pages/Champions/US/RetiredChampions.jsx": 9104,
	"./pages/ContactPage/ContactPage": 33808,
	"./pages/ContactPage/ContactPage.jsx": 33808,
	"./pages/Gallery/2007/Gallery2007": 41785,
	"./pages/Gallery/2007/Gallery2007.jsx": 41785,
	"./pages/Gallery/2008/Gallery2008": 48834,
	"./pages/Gallery/2008/Gallery2008.jsx": 48834,
	"./pages/Gallery/2009/Gallery2009": 6318,
	"./pages/Gallery/2009/Gallery2009.jsx": 6318,
	"./pages/Gallery/2010/Gallery2010": 38986,
	"./pages/Gallery/2010/Gallery2010.jsx": 38986,
	"./pages/Gallery/2011/Gallery2011": 88668,
	"./pages/Gallery/2011/Gallery2011.jsx": 88668,
	"./pages/Gallery/2012/Gallery2012": 16394,
	"./pages/Gallery/2012/Gallery2012.jsx": 16394,
	"./pages/Gallery/2013/Gallery2013": 39685,
	"./pages/Gallery/2013/Gallery2013.jsx": 39685,
	"./pages/Gallery/2014/Gallery2014": 21732,
	"./pages/Gallery/2014/Gallery2014.jsx": 21732,
	"./pages/Gallery/2015/Gallery2015": 73400,
	"./pages/Gallery/2015/Gallery2015.jsx": 73400,
	"./pages/Gallery/2016/Gallery2016": 9859,
	"./pages/Gallery/2016/Gallery2016.jsx": 9859,
	"./pages/Gallery/2017/Gallery2017": 21092,
	"./pages/Gallery/2017/Gallery2017.jsx": 21092,
	"./pages/Gallery/2018/Gallery2018": 14825,
	"./pages/Gallery/2018/Gallery2018.jsx": 14825,
	"./pages/Gallery/2019/Gallery2019": 28910,
	"./pages/Gallery/2019/Gallery2019.jsx": 28910,
	"./pages/Gallery/2019/GalleryPCA2019": 85284,
	"./pages/Gallery/2019/GalleryPCA2019.jsx": 85284,
	"./pages/Gallery/2020/Gallery2020": 78294,
	"./pages/Gallery/2020/Gallery2020.jsx": 78294,
	"./pages/Gallery/2021/Gallery2021": 57100,
	"./pages/Gallery/2021/Gallery2021.jsx": 57100,
	"./pages/Gallery/2022/Gallery2022": 28021,
	"./pages/Gallery/2022/Gallery2022.jsx": 28021,
	"./pages/Gallery/Gallery": 12342,
	"./pages/Gallery/Gallery.jsx": 12342,
	"./pages/Gallery/Main/Main": 8141,
	"./pages/Gallery/Main/Main.jsx": 8141,
	"./pages/Gallery/components/YearsPagination": 67275,
	"./pages/Gallery/components/YearsPagination.jsx": 67275,
	"./pages/HealthPages/HealthProtocol/HealthProtocol": 27083,
	"./pages/HealthPages/HealthProtocol/HealthProtocol.jsx": 27083,
	"./pages/HealthPages/HealthProtocol/KeyFeatures/KeyFeatures": 55090,
	"./pages/HealthPages/HealthProtocol/KeyFeatures/KeyFeatures.jsx": 55090,
	"./pages/HealthPages/HealthTestings/HealthTestings": 45395,
	"./pages/HealthPages/HealthTestings/HealthTestings.jsx": 45395,
	"./pages/HealthPages/HealthTestings/TestingTable/TestingTable": 75824,
	"./pages/HealthPages/HealthTestings/TestingTable/TestingTable.jsx": 75824,
	"./pages/HealthPages/ImmuneSystem/ImmuneSystem": 3565,
	"./pages/HealthPages/ImmuneSystem/ImmuneSystem.jsx": 3565,
	"./pages/HealthPages/NaturalRearings/NaturalRearings": 87020,
	"./pages/HealthPages/NaturalRearings/NaturalRearings.jsx": 87020,
	"./pages/HealthPages/RawDiet/RawDiet": 75763,
	"./pages/HealthPages/RawDiet/RawDiet.jsx": 75763,
	"./pages/HealthPages/SpayingAndNeutering/SpayingAndNeutering": 74138,
	"./pages/HealthPages/SpayingAndNeutering/SpayingAndNeutering.jsx": 74138,
	"./pages/HealthPages/Vaccination/Vaccination": 35611,
	"./pages/HealthPages/Vaccination/Vaccination.jsx": 35611,
	"./pages/PageNotFound/PageNotFound404": 20901,
	"./pages/PageNotFound/PageNotFound404.jsx": 20901,
	"./pages/PrivacyPolicy/PrivacyPolicy": 61422,
	"./pages/PrivacyPolicy/PrivacyPolicy.jsx": 61422,
	"./pages/PuppyPages/Breeding/Breeding": 81454,
	"./pages/PuppyPages/Breeding/Breeding.jsx": 81454,
	"./pages/PuppyPages/LitterPlans/LitterPlans": 25332,
	"./pages/PuppyPages/LitterPlans/LitterPlans.jsx": 25332,
	"./pages/PuppyPages/PastLitters/PastLitters": 66484,
	"./pages/PuppyPages/PastLitters/PastLitters.jsx": 66484,
	"./pages/Resources/PFD/BuyersEtiquette": 39437,
	"./pages/Resources/PFD/BuyersEtiquette.jsx": 39437,
	"./pages/Resources/PFD/PoisonousPlants": 46193,
	"./pages/Resources/PFD/PoisonousPlants.jsx": 46193,
	"./pages/Resources/PFD/PuppyBooks": 93797,
	"./pages/Resources/PFD/PuppyBooks.jsx": 93797,
	"./pages/Store/Store": 45135,
	"./pages/Store/Store.jsx": 45135,
	"./pages/TestimonialPages/Testimonial": 85872,
	"./pages/TestimonialPages/Testimonial.jsx": 85872,
	"./pages/TestimonialPages/components/TestimonialBody/TestimonialBody": 7063,
	"./pages/TestimonialPages/components/TestimonialBody/TestimonialBody.jsx": 7063,
	"./pages/TestimonialPages/pages/TestimonialPageFive": 72607,
	"./pages/TestimonialPages/pages/TestimonialPageFive.jsx": 72607,
	"./pages/TestimonialPages/pages/TestimonialPageFour": 79831,
	"./pages/TestimonialPages/pages/TestimonialPageFour.jsx": 79831,
	"./pages/TestimonialPages/pages/TestimonialPageOne": 52830,
	"./pages/TestimonialPages/pages/TestimonialPageOne.jsx": 52830,
	"./pages/TestimonialPages/pages/TestimonialPageSix": 58139,
	"./pages/TestimonialPages/pages/TestimonialPageSix.jsx": 58139,
	"./pages/TestimonialPages/pages/TestimonialPageThree": 60153,
	"./pages/TestimonialPages/pages/TestimonialPageThree.jsx": 60153,
	"./pages/TestimonialPages/pages/TestimonialPageTwo": 4922,
	"./pages/TestimonialPages/pages/TestimonialPageTwo.jsx": 4922,
	"./resources/Poisonouse-Plant-Guide.pdf": 71355,
	"./resources/PuppyDeposit.pdf": 33529,
	"./resources/puppy-books.pdf": 44642,
	"./resources/puppy-buyer-etiquette.pdf": 31501,
	"./resources/vaccines/Adverse Reactions - Dr. Jean Dodds.pdf": 90495,
	"./resources/vaccines/Junk Pet Food And The Damage Done - Dr. Tom Lonsdale.pdf": 15334,
	"./resources/vaccines/Puppy Vaccination A Guide To Reducing Risk - Dogs Naturally.pdf": 32174,
	"./resources/vaccines/Science Of Vaccine Damage - Catherine O'Driscoll.pdf": 29409,
	"./resources/vaccines/Vaccinations - How they work, when they work - Mogens Eliason.pdf": 65183,
	"./resources/vaccines/Vaccinations - More Is Not Better - Dogs Naturally.pdf": 78006,
	"./resources/vaccines/Why fat in the diet isn't 'bad' when you are a dog - Mogens Eliason.pdf": 10039
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18116;